import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useSeo } from "@/lib/seo";

const NotFound = () => {
  useSeo({ title: "Page introuvable · Entre Les Mondes", description: "", noindex: true });
  return (
  <div className="min-h-[70vh] flex items-center justify-center pt-24">
    <div className="text-center px-6">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="font-serif text-[6rem] leading-none text-sand-dark select-none"
      >
        404
      </motion.p>
      <h1 className="font-serif text-3xl text-bark mt-2 mb-4">Ce sentier s'arrête ici.</h1>
      <p className="text-fumee text-sm mb-8">La page cherchée s'est dissoute comme la fumée de sauge.</p>
      <Link to="/" data-testid="notfound-home"
        className="inline-flex px-8 py-3.5 rounded-full bg-earth text-sand text-sm hover:bg-terra hover:text-earth transition-colors duration-300">
        Retourner à l'accueil
      </Link>
    </div>
  </div>
  );
};

export default NotFound;
